import { useState } from "react"
import { motion } from "framer-motion"
import { returnThousanderBreakInNumber } from "../../../../services/functions"
import { ReactComponent as EURO } from "../../../../assets/EuroICON.svg"

type AssignBillElementType = {
    due_date: string
    invoice_date: string
    nr: string
    amount: string
    customer: string
    administrator: string
    func: () => void
    status: boolean
}


export function AssignPayReqElement(props: AssignBillElementType) {
    const [check, setcheck] = useState(false)
    return (
        <div className="w-full relative">
            <motion.div
                initial={{
                    x: 0,
                    backgroundColor: "#fff",
                }}
                animate={{
                    x: check ? "-18rem" : 0,
                    backgroundColor: check ? "#f2f5f8" : "#fff",
                }}
                transition={{
                    duration: 0.1,
                    type: "ease",
                }}
                className="z-10 bg-white flex flex-row w-full px-4 py-2 gap-2 relative border-t items-center cursor-pointer"
                onClick={() => setcheck(!check)}>
                <div className="w-20 mr-2 text-xs">Fällig am {props.due_date}</div>
                <div className="w-20 mx-2 text-xs">Ausgestellt {props.invoice_date}</div>
                <div className={`w-48 text-sm text-right font-bold ${props.status ? "text-green-500" : "text-red-600"}`}>
                    {returnThousanderBreakInNumber(Number(props?.amount))} €
                </div>
                <div className="w-64 text-sm text-right pr-2">Rechnung {props.nr}</div>
                <div className="w-full pl-2 pr-8 text-sm">
                    <p className="line-clamp-2 text-xs text-gray-400">
                        {props.customer}, {props.administrator}
                    </p>
                </div>
            </motion.div>
            <div
                onClick={() => {
                    props.func()
                    setcheck(!check)
                }}
                title="Rechnung als Bezahlt markieren"
                className="cursor-pointer absolute right-0 z-0 h-full bg-success w-72 top-0 flex items-center justify-center">
                <p className="uppercase font-semibold tracking-wider pr-1 text-sm">Diese Zahlung zuordnen</p>
                <EURO className="w-6 h-6" />
            </div>
        </div>
    )
}
